import React from 'react';
import PropTypes from 'prop-types';
import WithHover from 'WithHover';

const buttonStyle = {
  background: 'none',
  border: 'none',
  display: 'flex',
  outline: 'none',
  padding: 0,
};

const imgStyle = {
  alignSelf: 'flex-end',
  height: 98,
  marginRight: 20,
};

const sidebarSectionContainerStyle = {
  display: 'flex',
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 30,
};

export const SidebarSingleDownloadSection = (props) => {
  let imgSrc = `/images/rank-brain-2/download-${props.format}-2x.png`;
  if (props.isHover) {
    imgSrc = `/images/rank-brain-2/download-${props.format}-hover-2x.png`;
  }

  return (
    <div
      className="rank-brain-2-sidebar-section-container single-download-sample-section"
      style={sidebarSectionContainerStyle}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
    >
      <a
        style={buttonStyle}
        rel="noreferrer noopener"
        download
        href={`${window.cdnUrl}/downloads/${props.slug}/${props.slug}.${props.extension}`}
      >
        <img
          alt="Download"
          style={imgStyle}
          src={imgSrc}
        />
        <div>
          <h3>
            {props.heading}
          </h3>
          <p>
            {props.subheading}
          </p>
          <i>
            {props.text}
          </i>
        </div>

      </a>
    </div>
  );
};

SidebarSingleDownloadSection.defaultProps = {
  heading: '',
  isHover: false,
  subheading: '',
  text: '',
};

SidebarSingleDownloadSection.propTypes = {
  extension: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  heading: PropTypes.string,
  isHover: PropTypes.bool,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  text: PropTypes.string,
};

const SidebarSingleDownloadSectionWithHover = WithHover(SidebarSingleDownloadSection);

export default SidebarSingleDownloadSectionWithHover;



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarNavbar/SidebarSingleDownloadSection.jsx